module.exports = __webpack_public_path__ + "static/img/img_01.a0a433dc.png";